import * as faceMesh from "@mediapipe/face_mesh";



const mesh = new faceMesh.FaceMesh({
  locateFile: f =>
    `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${f}`
});

mesh.setOptions({
  maxNumFaces: 1,
  refineLandmarks: false, // 🔥 TURN OFF for speed
  minDetectionConfidence: 0.5,
  minTrackingConfidence: 0.5
});

let lastLandmarks = null;
let meshBusy = false;

mesh.onResults((res) => {
  meshBusy = false;
  if (res.multiFaceLandmarks?.length) {
    lastLandmarks = res.multiFaceLandmarks[0];
  }
});

// export async function extractSkinRGB(video, canvas) {

//   const ctx = canvas.getContext("2d");
//   ctx.drawImage(video, 0, 0, 128, 128);

//   // 🔥 Never await this
//   if (!meshBusy) {
//     meshBusy = true;
//     mesh.send({ image: canvas });
//   }

//   if (!lastLandmarks) return null;

//   let r = 0, g = 0, b = 0, c = 0;
//   const ROI = [10, 338, 297, 332, 284, 251, 389, 356];

//   for (let i = 0; i < ROI.length; i++) {
//     const id = ROI[i];
//     const x = (lastLandmarks[id].x * 128) | 0;
//     const y = (lastLandmarks[id].y * 128) | 0;

//     const pixel = ctx.getImageData(x, y, 1, 1).data;

//     r += pixel[0];
//     g += pixel[1];
//     b += pixel[2];
//     c++;
//   }

//   return [r / c, g / c, b / c];
// }




export async function extractSkinRGB(video, canvas) {
  const ctx = canvas.getContext("2d");

  // Draw scaled frame
  ctx.drawImage(video, 0, 0, 128, 128);

  // Send frame to mediapipe (non-blocking)
  if (!meshBusy) {
    meshBusy = true;
    mesh.send({ image: canvas });
  }

  if (!lastLandmarks || lastLandmarks.length === 0) {
    return null;
  }

  const width = 128;
  const height = 128;

  const imageData = ctx.getImageData(0, 0, width, height).data;

  let r = 0, g = 0, b = 0, count = 0;

  // Forehead region (better for rPPG)
  const ROI = [10, 338, 297, 332, 284, 251, 389, 356];

  const patchSize = 3; // small square around landmark

  for (let i = 0; i < ROI.length; i++) {
    const id = ROI[i];

    const cx = Math.floor(lastLandmarks[id].x * width);
    const cy = Math.floor(lastLandmarks[id].y * height);

    // Bounds check
    if (cx < 0 || cy < 0 || cx >= width || cy >= height) continue;

    for (let dx = -patchSize; dx <= patchSize; dx++) {
      for (let dy = -patchSize; dy <= patchSize; dy++) {

        const x = cx + dx;
        const y = cy + dy;

        if (x < 0 || y < 0 || x >= width || y >= height) continue;

        const index = (y * width + x) * 4;

        r += imageData[index];
        g += imageData[index + 1];
        b += imageData[index + 2];
        count++;
      }
    }
  }

  if (count === 0) return null;

  return [
    r / count,
    g / count,
    b / count
  ];
}



// import * as faceMesh from "@mediapipe/face_mesh";

// const mesh = new faceMesh.FaceMesh({
//   locateFile: f =>
//     `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${f}`
// });

// mesh.setOptions({
//   maxNumFaces: 1,
//   refineLandmarks: false,
//   minDetectionConfidence: 0.6,
//   minTrackingConfidence: 0.6
// });

// let lastLandmarks = null;
// let meshBusy = false;

// mesh.onResults((res) => {
//   meshBusy = false;
//   if (res.multiFaceLandmarks?.length) {
//     lastLandmarks = res.multiFaceLandmarks[0];
//   } else {
//     lastLandmarks = null;
//   }
// });

// export async function extractSkinRGB(video, canvas) {

//   const ctx = canvas.getContext("2d");
//   const width = 128;
//   const height = 128;

//   ctx.drawImage(video, 0, 0, width, height);

//   if (!meshBusy) {
//     meshBusy = true;
//     mesh.send({ image: canvas });
//   }

//   if (!lastLandmarks) return null;

//   const imageData = ctx.getImageData(0, 0, width, height).data;

//   const ROI = [10, 338, 297, 332, 284, 251, 389, 356];
//   const patch = 3;

//   let r = 0, g = 0, b = 0, count = 0;

//   for (let id of ROI) {
//     const cx = Math.floor(lastLandmarks[id].x * width);
//     const cy = Math.floor(lastLandmarks[id].y * height);

//     for (let dx = -patch; dx <= patch; dx++) {
//       for (let dy = -patch; dy <= patch; dy++) {

//         const x = cx + dx;
//         const y = cy + dy;

//         if (x < 0 || y < 0 || x >= width || y >= height) continue;

//         const index = (y * width + x) * 4;

//         r += imageData[index];
//         g += imageData[index + 1];
//         b += imageData[index + 2];
//         count++;
//       }
//     }
//   }

//   if (!count) return null;

//   return [r / count, g / count, b / count];
// }


// import * as faceMesh from "@mediapipe/face_mesh";

// const mesh = new faceMesh.FaceMesh({
//   locateFile: f =>
//     `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${f}`
// });

// mesh.setOptions({
//   maxNumFaces: 1,
//   refineLandmarks: false,
//   minDetectionConfidence: 0.6,
//   minTrackingConfidence: 0.6
// });

// let lastLandmarks = null;
// let busy = false;

// mesh.onResults(res => {
//   busy = false;
//   if (res.multiFaceLandmarks?.length) {
//     lastLandmarks = res.multiFaceLandmarks[0];
//   }
// });

// export async function extractSkinRGB(video, canvas) {

//   const ctx = canvas.getContext("2d");
//   ctx.drawImage(video, 0, 0, 128, 128);

//   if (!busy) {
//     busy = true;
//     mesh.send({ image: canvas });
//   }

//   if (!lastLandmarks) return null;

//   const imageData = ctx.getImageData(0, 0, 128, 128).data;

//   const ROI = [10,338,297,332,284,251,389,356];

//   let r=0,g=0,b=0,count=0;

//   for (let id of ROI) {

//     const x = Math.floor(lastLandmarks[id].x * 128);
//     const y = Math.floor(lastLandmarks[id].y * 128);

//     for (let dx=-2; dx<=2; dx++) {
//       for (let dy=-2; dy<=2; dy++) {

//         const px = x+dx;
//         const py = y+dy;

//         if(px<0||py<0||px>=128||py>=128) continue;

//         const idx = (py*128 + px)*4;

//         r += imageData[idx];
//         g += imageData[idx+1];
//         b += imageData[idx+2];
//         count++;
//       }
//     }
//   }

//   return count ? [r/count, g/count, b/count] : null;
// }
